import { render } from "./PremiumUpgrade.vue?vue&type=template&id=5d8a3792&scoped=true"
import script from "./PremiumUpgrade.vue?vue&type=script&lang=js"
export * from "./PremiumUpgrade.vue?vue&type=script&lang=js"

import "./PremiumUpgrade.vue?vue&type=style&index=0&id=5d8a3792&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d8a3792"],['__file',"PremiumUpgrade.vue"]])

export default __exports__